<template>
  <div class="col-12">

    <div class=" row text-center ml-5">
      <h3 class="ui inverted purple text"><strong>Select Currency</strong>
      </h3>
      <p class="text-muted fw-light mt-4">Please note every account creation request made on this platform requires a
        deposit through EcoCash.</p>
    </div>

    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-9">

        <div class="row mb-5">
          <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>ZWL</strong></h4>
                <p class="card-text text-muted fw-light">Zimbabwean Dollar denominated account</p>
                <button class="ui purple right floated  button" @click="zwl()">
                  Next
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-6 mb-3">
            <div class="card card-shadow">
              <div class="card-body">
                <h4 class="card-title"><strong>USD</strong></h4>
                <p class="card-text text-muted fw-light">United States Dollar denominated account</p>
                <button class="ui purple right floated button" @click="usd()">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5">
          <button @click="back()" class="ui grey button fluid">Back</button>
        </div>

      </div>
    </div>


  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";

export default {
  name: "DiasporaCurrencyType",
  data() {
    return { accounts: [], };
  },
  mounted() {
    // localStorage.clear();
    //   this.getAccountsApplications();
  },
  methods: {

    // getAccountsApplications() {
    //   this.get(URLS.accounts + '/active-accounts', false)
    //     .then(res => {
    //       this.accounts = res.body;
    //       if (!res) return;
    //       if (res.errors) return this.errors = res.errors;

    //     })
    // },
    back() {
      this.$router.push("/account-opening/account-type");

    },
    zwl() {

      this.get(URLS.accounts + '/active-accounts', false)
        .then(res => {
          this.accounts = res.body;

          let getItems = this.accounts.filter((item) => {
            return (item.accountType === 'DIASPORA' && item.currency === 'ZWL')
          })
          console.log(getItems.length);
          if (getItems.length > 0) {
            this.$router.push("/account-opening/t24-account-failed");
          }
          else {
            localStorage.setItem("currency-type", "ZWL");
            this.$router.push("/account-opening/diaspora-customer-details");
          }

          if (!res) return;
          if (res.errors) return this.errors = res.errors;

        })


    },
    usd() {

      this.get(URLS.accounts + '/active-accounts', false)
        .then(res => {
          this.accounts = res.body;

          let getItems = this.accounts.filter((item) => {
            return (item.accountType === 'DIASPORA' && item.currency === 'USD')
          })
          if (getItems.length > 0) {
            this.$router.push("/account-opening/t24-account-failed");
          }
          else {
            localStorage.setItem("currency-type", "USD");
            this.$router.push("/account-opening/diaspora-customer-details");
          }

          if (!res) return;
          if (res.errors) return this.errors = res.errors;

        })


    },
    submitForm() { },
    ...baseMethods,
  }
};
</script>